import axios from 'axios';
import store from '@/store';
import router from '@/router';

const instance = axios.create();
function AuthException(message) {
    this.message = message;
    this.name = 'AuthException';
}

instance.interceptors.request.use( (config) => {
    const token = store.state.user.access_token;
    const expiredDate = new Date(store.state.user.expires_in * 1000);
    let currentDate = new Date();
    if(token && currentDate <= expiredDate) {
        config.headers.authorization = `bearer ${token}`;
    }else{
        if (expiredDate !== undefined && token) {
            console.log('Logged out through javascript, no need to send request.')
            store.commit('user/clearUser');
            store.commit('ward/clearOrgFilter');
            router.push({ name:"logout", params: {"logOutText": "Your Session has expired. Please log back in."}});
            return Promise.reject(new AuthException('Session has expired, Please log back in.'));
        }
    }
    return config;
}, function(err){
    return Promise.reject(err);
});

instance.interceptors.response.use(
    (response) => {
    return response;
    },
    (err) => {
    if (err.response === undefined){
        store.commit('user/clearUser');
        store.commit('ward/clearOrgFilter');
        router.push("/login");
        return Promise.reject(err);
    }
      if(err.response.status === 400) {
        return Promise.reject(err);
      }
    //console.log(err.response.data);
    if(err.response.status === 401 && !store.state.user.loggedin && store.state.user.access_token === "" || store.state.user.access_token === null ){
        //console.log("you got this because you dont have a token so you need to login");
        //console.log(err.response.data.detail);
        store.commit('user/clearUser');
        store.commit('ward/clearOrgFilter');
        router.push("/login");
        return Promise.reject(err);
    }

    if(err.response.status === 401 && err.response.data.detail !== 'Incorrect username or password') {
        //console.log("do not come here when you are trying to login")
        store.commit('user/clearUser');
        store.commit('ward/clearOrgFilter');
        router.push({ name:"logout", params: {"logOutText": "Your Session timed out please log in again"}});
    }
    return Promise.reject(err);
});

export const authAxios = instance;


